import { render } from "./FlashcardDeck.vue?vue&type=template&id=0bb906f9&scoped=true"
import script from "./FlashcardDeck.vue?vue&type=script&lang=js"
export * from "./FlashcardDeck.vue?vue&type=script&lang=js"

import "./FlashcardDeck.vue?vue&type=style&index=0&id=0bb906f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bb906f9"]])

export default __exports__